export enum DatasetType {
  ERZEUGUNG = "0",
  BEDARF = "1"
}